import './Chip.scss';
import React from 'react';

export type ChipColor =
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'out'
    | 'lilas'
    | 'waiting'
    | 'inactive'
    | 'active'
    | 'waking'
    | 'punctual'
    | 'regular'
    | 'intensive';

export type ChipProps = {
    label?: string;
    color?: ChipColor;
    className?: string;
    compact?: boolean;
};

export const Chip: React.FC<React.PropsWithChildren & ChipProps> = ({ label, color = 'primary', children, className, compact }) => {
    return <div className={`chip chip-${color} ${className ?? ''} ${compact && 'compact'}`}>{label ?? children}</div>;
};
